import { STATUSPAGE } from '@repo/ui';
import {
  GetAllCancellationReasonsUseCaseInterface,
  HandleMissedActivitiesJustificationsUseCaseInterface,
} from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import {
  clearCancellationReasons,
  loadCancellationReasons,
} from 'presentation/config/store/cancellation-reasons/cancellation-reasons-slice';
import {
  clearMissedActivitiesJustifications,
  loadMissedActivitiesJustifications,
} from 'presentation/config/store/reports/missed-activities-justifications-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useMissedActivitiesJustifications = () => {
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const [statusLoading, setStatusLoading] = useState<STATUSPAGE>(
    STATUSPAGE.DONE,
  );

  const dispatch = useDispatch();
  const { reportService, cancellationReasonsService } = useService();

  const { data: missedActivitiesJustifications } = useAppSelector(
    (state) => state.missedActivitiesJustifications,
  );
  const { cancellationReasons } = useAppSelector(
    (state) => state.cancellationReasons,
  );

  const requestMissedActivitiesJustificationsJSON = useCallback(
    async (
      params?: HandleMissedActivitiesJustificationsUseCaseInterface.Params,
    ) => {
      setStatusLoading(STATUSPAGE.LOADING);

      await reportService
        .handleMissedActivitiesJustifications(params)
        .then((res) => {
          dispatch(loadMissedActivitiesJustifications(res));
        })
        .catch((err) => {
          dispatch(clearMissedActivitiesJustifications());
          notifyError(err.message);
        })
        .finally(() => {
          setStatusLoading(STATUSPAGE.DONE);
          setHasFetchedData(true);
        });
    },
    [],
  );

  const handleMissedActivitiesJustificationsFile = useCallback(
    async (
      params?: HandleMissedActivitiesJustificationsUseCaseInterface.Params,
    ) => {
      setStatusLoading(STATUSPAGE.LOADING);

      await reportService
        .handleMissedActivitiesJustifications(params)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/pdf`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setStatusLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const requestGetAllCancellationReasons = useCallback(async () => {
    await cancellationReasonsService
      .getAllCancellationReasons()
      .then((res: GetAllCancellationReasonsUseCaseInterface.Result) => {
        dispatch(loadCancellationReasons(res));
      })
      .catch((err) => {
        dispatch(clearCancellationReasons());
        console.log(err);
      });
  }, []);

  return {
    statusLoading,
    hasFetchedData,
    cancellationReasons,
    missedActivitiesJustifications,
    requestGetAllCancellationReasons,
    handleMissedActivitiesJustificationsFile,
    requestMissedActivitiesJustificationsJSON,
  };
};
